import ValueRule from '../ValueRule';

const MaximumValue = () => {
  return <ValueRule type='maximum_value' label='Maximum value' />;
};

export default MaximumValue;
